module.exports = __webpack_public_path__ + "static/img/naturalCircle3h.6ac20ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle3h.svg
// module id = q5iq
// module chunks = 1